import React from 'react';
import cx from 'classnames';
import cs from '../index.module.scss';

const ExchangeIcon: React.FC<any> = ({ className, ...restProps }) => (
  <span className={cx(cs.container, className)} {...restProps}>
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34 18C34 26.8366 26.8366 34 18 34C9.16344 34 2 26.8366 2 18C2 9.16344 9.16344 2 18 2C26.8366 2 34 9.16344 34 18ZM36 18C36 27.9411 27.9411 36 18 36C8.05887 36 0 27.9411 0 18C0 8.05887 8.05887 0 18 0C27.9411 0 36 8.05887 36 18ZM9 13C9 11.8954 9.89543 11 11 11H25C26.1046 11 27 11.8954 27 13V21C27 22.1046 26.1046 23 25 23H20V24H23.5C23.7761 24 24 24.2239 24 24.5C24 24.7761 23.7761 25 23.5 25H12.5C12.2239 25 12 24.7761 12 24.5C12 24.2239 12.2239 24 12.5 24H16V23H11C9.89543 23 9 22.1046 9 21V13ZM19 17.293L23 13.2929L24.207 14.5H25V15.5H23.7929L23 14.707L19 18.7071L17 16.707L14 19.7071L13 18.707L12.2071 19.5H11V18.5H11.792L13 17.2929L14 18.293L17 15.2929L19 17.293Z"
        fill="#ED0070"
      />
    </svg>
  </span>
);

export default ExchangeIcon;
